import { render, staticRenderFns, recyclableRender, components } from "./u-form.vue?vue&type=template&id=ed64ceb2&scoped=true&"
var renderjs
import script from "./u-form.vue?vue&type=script&lang=js&"
export * from "./u-form.vue?vue&type=script&lang=js&"
import style0 from "./u-form.vue?vue&type=style&index=0&id=ed64ceb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed64ceb2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-form/u-form.vue"
export default component.exports